/**
 * KURULUM REHBERI
 *
 * "Outlook'a nasil kurarim" sorusunun panel icindeki cevabi. Once otomatik
 * yolu gosterir (kullanici adres + parola yazar, gerisi kendiliginden olur),
 * elle ayar bilgilerini ise ikinci planda tutar — cunku elle ayar yapan
 * kullanici cogu zaman bir yeri yanlis yazar ve sorun bize doner.
 */
import { useState } from "react";
import { api, oturum } from "../api";
import { Bildirim, Bos, Durum, Kart, Rozet, Tablo, useCek } from "../ui";

type Istemci = "outlook" | "thunderbird" | "iphone" | "android" | "takvim" | "elle";

const SEKMELER: Array<{ id: Istemci; ad: string }> = [
  { id: "outlook", ad: "Outlook" },
  { id: "iphone", ad: "iPhone / iPad" },
  { id: "android", ad: "Android" },
  { id: "thunderbird", ad: "Thunderbird" },
  { id: "takvim", ad: "Takvim ve Kişiler" },
  { id: "elle", ad: "Elle ayar" },
];

export function Kurulum() {
  const k = oturum.kullanici();
  const [eposta, setEposta] = useState(k?.rol === "kutu" ? k.eposta : "");
  const [sekme, setSekme] = useState<Istemci>("outlook");
  const ayarlar = useCek(() => api.istemciAyarlari(eposta), [eposta]);

  return (
    <>
      <div className="baslik">
        <div>
          <h1>E-posta kurulumu</h1>
          <p>
            Posta programınız ayarları kendisi bulabilir. Çoğu durumda yapmanız gereken tek şey
            adresinizi ve parolanızı yazmak.
          </p>
        </div>
      </div>

      <Kart baslik="Hangi adres için?">
        <label className="alan">
          <span>E-posta adresi</span>
          <input
            value={eposta}
            onChange={(e) => setEposta(e.target.value.trim())}
            placeholder="ad@kurumunuz.com"
            autoComplete="email"
          />
          <small>
            Adresi yazınca aşağıdaki ayarlar o adrese göre gösterilir. Adres yazmadan da genel
            ayarları görebilirsiniz.
          </small>
        </label>
      </Kart>

      <Durum cekim={ayarlar}>
        {(y) => {
          const a = y.veri;
          const alan = eposta.includes("@") ? eposta.split("@")[1] : null;
          return (
            <>
              <div className="sekmeler">
                {SEKMELER.map((s) => (
                  <button
                    key={s.id}
                    className={"sekme" + (sekme === s.id ? " etkin" : "")}
                    onClick={() => setSekme(s.id)}
                  >
                    {s.ad}
                  </button>
                ))}
              </div>

              {sekme === "outlook" && (
                <Kart baslik="Outlook">
                  <ol className="adimlar">
                    <li>
                      Outlook'u açın. <strong>Dosya → Hesap Ekle</strong> yolunu izleyin.
                    </li>
                    <li>
                      E-posta adresinizi yazıp <strong>Bağlan</strong>'a basın.
                    </li>
                    <li>
                      Parolanızı yazın. Outlook sunucu adını ve portları <strong>kendisi bulur</strong>;
                      elle bir şey girmeniz gerekmez.
                    </li>
                    <li>Bitir'e basın. Postalarınız inmeye başlar.</li>
                  </ol>
                  <Bildirim>
                    Outlook ayarları bulamazsa alan adınızın DNS kayıtlarında <code>autodiscover</code>{" "}
                    kaydı eksik demektir. Alan adları ekranında hangi kaydın eksik olduğunu
                    görebilirsiniz.
                  </Bildirim>
                </Kart>
              )}

              {sekme === "iphone" && (
                <Kart baslik="iPhone / iPad">
                  {eposta.includes("@") ? (
                    <>
                      <p>
                        En kolay yol: aşağıdaki kurulum profilini indirin. Telefon{" "}
                        <strong>postayı, takvimi ve kişileri birlikte</strong> ekler; siz yalnızca
                        parolanızı yazarsınız.
                      </p>
                      <p>
                        <button className="dugme ana" onClick={() => api.appleProfil(eposta)}>
                          Kurulum profilini indir
                        </button>
                      </p>
                      <Bildirim tur="uyari">
                        Profilin içinde parolanız YOKTUR; telefon kurulum sırasında size sorar.
                        İndirdikten sonra <strong>Ayarlar → Genel → VPN ve Cihaz Yönetimi</strong>{" "}
                        bölümünden onaylamanız gerekir.
                      </Bildirim>
                      <p style={{ marginTop: 14 }}>
                        <strong>Profil kullanmak istemezseniz:</strong>
                      </p>
                    </>
                  ) : (
                    <p>Kurulum profili için yukarıya e-posta adresinizi yazın.</p>
                  )}
                  <ol className="adimlar">
                    <li>
                      <strong>Ayarlar → Uygulamalar → Mail → Mail Hesapları → Hesap Ekle → Diğer</strong>
                    </li>
                    <li>
                      <strong>Mail Hesabı Ekle</strong>'ye dokunun, ad, adres ve parolanızı yazın.
                    </li>
                    <li>
                      <strong>IMAP</strong> sekmesinde kalın; gelen ve giden sunucu için{" "}
                      <code>{a.imap.sunucu}</code> yazın.
                    </li>
                  </ol>
                </Kart>
              )}

              {sekme === "android" && (
                <Kart baslik="Android (Gmail uygulaması)">
                  <ol className="adimlar">
                    <li>
                      Gmail uygulamasını açın. Sağ üstteki profil resmine dokunup{" "}
                      <strong>Başka hesap ekle</strong>'yi seçin.
                    </li>
                    <li>
                      <strong>Diğer</strong>'i seçin ve adresinizi yazın.
                    </li>
                    <li>
                      <strong>KİŞİSEL (IMAP)</strong> seçeneğine dokunun, parolanızı yazın.
                    </li>
                    <li>
                      Sunucu sorulursa gelen için <code>{a.imap.sunucu}</code> (port 993, SSL), giden
                      için aynı adres (port 587, STARTTLS).
                    </li>
                  </ol>
                  <Bildirim>
                    Kullanıcı adı her zaman <strong>tam e-posta adresinizdir</strong> — yalnızca @
                    işaretinden önceki kısım değil. En sık yapılan hata budur.
                  </Bildirim>
                </Kart>
              )}

              {sekme === "thunderbird" && (
                <Kart baslik="Thunderbird">
                  <ol className="adimlar">
                    <li>
                      <strong>Hesap Ayarları → Hesap İşlemleri → E-posta Hesabı Ekle</strong>
                    </li>
                    <li>Adınızı, e-posta adresinizi ve parolanızı yazın.</li>
                    <li>
                      <strong>Devam</strong>'a basın. Thunderbird ayarları kendisi bulur; gelen kutusu
                      için IMAP önerdiğini doğrulayıp <strong>Bitti</strong>'ye basın.
                    </li>
                  </ol>
                  {a.otomatik.autoconfig && (
                    <p>
                      <small>
                        Thunderbird'ün okuduğu adres: <code>{a.otomatik.autoconfig}</code>
                      </small>
                    </p>
                  )}
                </Kart>
              )}

              {sekme === "takvim" && (
                <Kart baslik="Takvim ve Kişiler">
                  <p>
                    Posta kutunuz aynı zamanda bir <strong>takvim ve kişi rehberi</strong> barındırır.
                    Ayrı bir hesap açmanıza gerek yok: adresiniz ve parolanız aynıdır. Birden fazla
                    cihazdan bağlandığınızda takviminiz ve kişileriniz kendiliğinden eşitlenir.
                  </p>

                  <h3>iPhone / iPad</h3>
                  <p>
                    Yukarıdaki <strong>iPhone</strong> sekmesindeki kurulum profilini indirdiyseniz
                    takvim ve kişiler <strong>zaten kuruldu</strong>; başka bir şey yapmanız gerekmez.
                    Elle kurmak isterseniz:
                  </p>
                  <ol className="adimlar">
                    <li>
                      <strong>Ayarlar → Uygulamalar → Takvim → Takvim Hesapları → Hesap Ekle → Diğer</strong>
                    </li>
                    <li>
                      <strong>CalDAV Hesabı Ekle</strong>'ye dokunun.
                    </li>
                    <li>
                      Sunucu: <code>{a.caldav?.sunucu ?? a.imap.sunucu}</code> · Kullanıcı adı: tam e-posta
                      adresiniz · Parola: kutunuzun parolası.
                    </li>
                    <li>
                      Kişiler için aynı adımları <strong>Ayarlar → Uygulamalar → Kişiler</strong> altında
                      <strong> CardDAV Hesabı Ekle</strong> ile tekrarlayın.
                    </li>
                  </ol>

                  <h3>Android</h3>
                  <p>
                    Android'de takvim ve kişi eşitlemesi için bir DAV istemcisi gerekir; en yaygını{" "}
                    <strong>DAVx⁵</strong> uygulamasıdır. Uygulamayı kurup{" "}
                    <strong>“E-posta adresiyle giriş”</strong> seçeneğini kullanın — adresinizi ve
                    parolanızı yazmanız yeterlidir, sunucuyu kendisi bulur.
                  </p>

                  <h3>Thunderbird</h3>
                  <ol className="adimlar">
                    <li>
                      <strong>Takvim → Yeni Takvim → Ağ üzerinde</strong>
                    </li>
                    <li>
                      <strong>CalDAV</strong>'ı seçin, kullanıcı adı olarak tam e-posta adresinizi yazın.
                    </li>
                    <li>
                      Konum: <code>https://{a.caldav?.sunucu ?? a.imap.sunucu}{a.caldav?.yol ?? "/dav/cal"}</code>
                    </li>
                  </ol>

                  <h3>Outlook</h3>
                  <Bildirim tur="uyari">
                    Masaüstü Outlook takvim için CalDAV desteklemez. Outlook kullanıcıları takvimi{" "}
                    <a href={a.webmail} target="_blank" rel="noreferrer">
                      webmail
                    </a>{" "}
                    üzerinden ya da telefonlarındaki takvim uygulamasından kullanabilir. Postada
                    böyle bir kısıt yoktur.
                  </Bildirim>
                </Kart>
              )}

              {sekme === "elle" && (
                <Kart baslik="Elle ayar">
                  <Tablo basliklar={["", "Sunucu", "#Port", "Güvenlik"]}>
                    <tr>
                      <td>
                        <strong>Gelen (IMAP)</strong>
                      </td>
                      <td>
                        <code>{a.imap.sunucu}</code>
                      </td>
                      <td className="sayi">{a.imap.port}</td>
                      <td>{a.imap.guvenlik}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Giden (SMTP)</strong>
                      </td>
                      <td>
                        <code>{a.smtp.sunucu}</code>
                      </td>
                      <td className="sayi">{a.smtp.port}</td>
                      <td>{a.smtp.guvenlik}</td>
                    </tr>
                    {a.caldav && (
                      <tr>
                        <td>
                          <strong>Takvim (CalDAV)</strong>
                        </td>
                        <td>
                          <code>
                            {a.caldav.sunucu}
                            {a.caldav.yol}
                          </code>
                        </td>
                        <td className="sayi">{a.caldav.port}</td>
                        <td>{a.caldav.guvenlik}</td>
                      </tr>
                    )}
                    {a.carddav && (
                      <tr>
                        <td>
                          <strong>Kişiler (CardDAV)</strong>
                        </td>
                        <td>
                          <code>
                            {a.carddav.sunucu}
                            {a.carddav.yol}
                          </code>
                        </td>
                        <td className="sayi">{a.carddav.port}</td>
                        <td>{a.carddav.guvenlik}</td>
                      </tr>
                    )}
                    {a.sieve && (
                      <tr>
                        <td>
                          <strong>Kurallar (Sieve)</strong>
                        </td>
                        <td>
                          <code>{a.sieve.sunucu}</code>
                        </td>
                        <td className="sayi">{a.sieve.port}</td>
                        <td>{a.sieve.guvenlik}</td>
                      </tr>
                    )}
                  </Tablo>
                  <dl className="ikili" style={{ marginTop: 14 }}>
                    <dt>Kullanıcı adı</dt>
                    <dd>{a.kullaniciAdi}</dd>
                    <dt>Parola</dt>
                    <dd>posta kutunuzun parolası</dd>
                    <dt>Kimlik doğrulama</dt>
                    <dd>normal parola</dd>
                    <dt>Webmail</dt>
                    <dd>
                      <a href={a.webmail} target="_blank" rel="noreferrer">
                        {a.webmail}
                      </a>
                    </dd>
                  </dl>
                  <Bildirim tur="uyari">
                    Giden sunucu için de <strong>kimlik doğrulaması açık</strong> olmalıdır. Kapalı
                    bırakırsanız posta gönderemezsiniz — sunucu kimliksiz gönderimi kabul etmez.
                  </Bildirim>
                </Kart>
              )}

              {alan && (
                <Kart baslik="Otomatik ayar adresleri">
                  <p>
                    Bunlar teknik ayrıntıdır; sorun yaşarsanız destek ekibine iletmeniz işi
                    hızlandırır.
                  </p>
                  <dl className="ikili">
                    <dt>Thunderbird</dt>
                    <dd>
                      <code>{a.otomatik.autoconfig}</code>
                    </dd>
                    <dt>Outlook</dt>
                    <dd>
                      <code>{a.otomatik.autodiscover}</code>
                    </dd>
                  </dl>
                </Kart>
              )}

              <Kart baslik="Sık karşılaşılan sorunlar">
                <dl className="ikili">
                  <dt>Parola kabul edilmiyor</dt>
                  <dd>
                    Kullanıcı adı tam e-posta adresi olmalı. Kutunuz yöneticiniz tarafından geçici
                    olarak kapatılmış da olabilir; bu durumda gelen postalarınız birikmeye devam eder.
                  </dd>
                  <dt>Posta alıyorum, gönderemiyorum</dt>
                  <dd>
                    Giden sunucu ayarında kimlik doğrulama kapalıdır ya da alan adınızın DNS kayıtları
                    tamamlanmamıştır. İkincisi düzelene kadar gönderim kapalı tutulur.
                  </dd>
                  <dt>Postalarım karşı tarafta spam'e düşüyor</dt>
                  <dd>
                    SPF, DKIM ve DMARC kayıtlarınız eksik olabilir. Alan adları ekranında hangi
                    kaydın eksik olduğu yazar.
                  </dd>
                  <dt>Telefonumda eski postalar görünmüyor</dt>
                  <dd>
                    Telefonlar genelde son bir aylık postayı indirir. Hesap ayarlarından “eşitlenecek
                    süre”yi uzatabilirsiniz. Postalarınız sunucuda durmaya devam eder.
                  </dd>
                </dl>
              </Kart>
            </>
          );
        }}
      </Durum>
    </>
  );
}
